import meanduLogo from "../../assets/img/meandu-logo.svg";

import "./LoadingSpinner.scss";

export const LoadingSpinner = () => <img src={meanduLogo} alt="Loading" className="loading-spinner" />;
